import { combineReducers, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { reducers } from './modules';

const rootReducers = combineReducers(reducers);
let store;
if(process.env.REACT_APP_ENV !== 'prod') {
  store = createStore(
    rootReducers,
    applyMiddleware(thunk)
  );
}
else {
  store = createStore(
    rootReducers,
    applyMiddleware(thunk)
  );
}

export const isInRole = (roles) => {
  let users;
  if(roles && roles.length > 0){
    let currentUserRoles = store.getState().account.roles;
    users = roles.filter(x => currentUserRoles.includes(x));
  }
  else{
    return true;
  }
  // let users = store.getState().account.roles.filter(x => x === "AccountOwner");
  if (users.length > 0) {
    return true;
  }
  return false;
}
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js